import type { Session } from '@supabase/supabase-js';
import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { supabase } from './supabase';

type Sesion = { sesion: Session | null; cargando: boolean };

const Contexto = createContext<Sesion>({ sesion: null, cargando: true });

export function ProveedorDeSesion({ children }: { children: ReactNode }) {
  const [estado, setEstado] = useState<Sesion>({ sesion: null, cargando: true });

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => setEstado({ sesion: data.session, cargando: false }));
    const { data } = supabase.auth.onAuthStateChange((_evento, sesion) => setEstado({ sesion, cargando: false }));
    return () => data.subscription.unsubscribe();
  }, []);

  return <Contexto.Provider value={estado}>{children}</Contexto.Provider>;
}

export const useSesion = () => useContext(Contexto);

/** Iniciales para el círculo del usuario ("Santiago Salazar" → "SS"). */
export function iniciales(correo?: string | null): string {
  if (!correo) return '··';
  const nombre = correo.split('@')[0] ?? '';
  const partes = nombre.split(/[._-]+/).filter(Boolean);
  return (partes.length > 1 ? partes[0]![0]! + partes[1]![0]! : nombre.slice(0, 2)).toUpperCase();
}
